<template>
  <div class="container">
    <div class="row">
      <div class="col s6">
        <h5>{{ $t('Admin/Bot Handover') }}</h5>
      </div>

      <div class="col s6 right-align">
        <div
          class="btn-floating btn-outline-red text-xs-center"
          style="margin-top: 5px; margin-bottom: 5px"
          v-if="!isEditCommand"
          @click="editCommand"
        >
          <em class="fa fa-pencil-alt middle" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col s5">
        <div class="caption" style="margin-top: 10px">{{ $t('Shortcut to pause a bot') }}</div>
        <div class="form-control" :class="{ 'has-error': errors.has('changestatetoadmin') }">
          <input
            name="changestatetoadmin"
            v-validate="'required'"
            small
            v-if="isEditCommand"
            type="text"
            v-model="hotkey.changestatetoadmin"
          />
          <div v-else class="primary--text">{{ hotkey.changestatetoadmin }}</div>
          <span class="text-error" v-if="errors.has('changestatetoadmin')">{{
            errors.first('changestatetoadmin')
          }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col s5">
        <div class="caption" style="margin-top: 10px">{{ $t('Shortcut to continue a bot') }}</div>
        <div class="form-control" :class="{ 'has-error': errors.has('changestatetobot') }">
          <input
            v-validate="'required'"
            name="changestatetobot"
            small
            v-if="isEditCommand"
            type="text"
            v-model="hotkey.changestatetobot"
          />
          <div v-else class="primary--text">{{ hotkey.changestatetobot }}</div>
          <span class="text-error" v-if="errors.has('changestatetobot')">{{
            errors.first('changestatetobot')
          }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div style="text-align: center" class="col s12">
        <div v-if="isEditCommand">
          <v-btn @click="cancel" color="grey" :disabled="loading" outline>{{ $t('Cancel') }}</v-btn>
          <v-btn @click="changeBotState" color="primary" :loading="loading" depressed>{{
            $t('Save')
          }}</v-btn>
          <!-- 
          <a @click="cancel" class="btn btn-outline-gray">{{$t('Cancel')}}</a>
          <a @click="changeBotState" class="btn">{{$t('Save')}}</a>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'

export default {
  data() {
    return {
      hotkey: {
        changestatetoadmin: '',
        changestatetobot: ''
      },
      loading: false,
      cache: '',
      isEditCommand: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      setting: 'setting'
    })
  },
  mounted() {
    if (this.setting && this.setting.change_state_to_admin) {
      this.hotkey.changestatetoadmin = this.setting.change_state_to_admin.contentvalue
    }
    if (this.setting && this.setting.change_state_to_bot) {
      this.hotkey.changestatetobot = this.setting.change_state_to_bot.contentvalue
    }
  },
  methods: {
    cancel() {
      this.isEditCommand = false
      this.hotkey = JSON.parse(this.cache)
    },
    editCommand() {
      this.isEditCommand = true
      this.cache = JSON.stringify(this.hotkey)
    },
    changeBotState(type) {
      let vm = this
      this.loading = true
      let obj = {
        pageid: this.selectedBot.pageid,
        input: {
          changestatetoadmin: this.hotkey.changestatetoadmin,
          changestatetobot: this.hotkey.changestatetobot
        }
      }

      api.putchangebotstate(obj, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.isEditCommand = false
        vm.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/adminHandOver.vue